import { DeleteFilled } from "@ant-design/icons";
import { Button, Card, Modal, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import AddProjectTeam from "./AddProjectTeam";
import "../Project.css";

import {
	deleteProjectTeam,
	loadAllProjectTeam,
} from "../../../redux/rtk/features/projectManagement/project/projectTeam/projectTeam";
import ViewBtn from "../../Buttons/ViewBtn";
import ProjectTeamStatusUpdatePopup from "../../UI/PopUp/ProjectManagemnet/ProjectTeamStatusUpdatePopup";


const ProjectTeam = () => {
	const { list=[], loading } = useSelector((state) => state?.projectTeam);
	// const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));
	const addKeys = (arr = []) => Array.isArray(arr) ? arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 })) : [];


	const { id: projectIdFromUrl } = useParams();
// console.log(projectIdFromUrl)

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Team Name",
			dataIndex: "projectTeamName",
			key: "projectTeamName",
		},
		{
			id: 4,
			title: "Action",
			key: "action",
			render: ({id, projectTeamName, status}) => (
				<div className='flex justify-start'>
					<ViewBtn path={`/admin/team/${id}`} />
					<ProjectTeamStatusUpdatePopup
						projectId={id}
						teamName={projectTeamName}
						status={status}
					/>
					<Button
						size='small'
						style={{ width: "28px", height: "22px" }}
						type='danger'
						onClick={() => onDelete(id)}
						loading={deleteLoader}
						icon={<DeleteFilled />}></Button>
				</div>
			),
		},
	];
	const dispatch = useDispatch();
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const [deleteLoader, setDeleteLoader] = useState(false);
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [teamModalOpen, setTeamModalOpen] = useState(false);

	useEffect(() => {
		dispatch(loadAllProjectTeam());
	}, []);

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const onDelete = async (id) => {
		// console.log(id);
		setDeleteLoader(true);
		const resp = await dispatch(deleteProjectTeam(id));
		if (resp.payload.message === "success") {
			setDeleteLoader(false);
			dispatch(loadAllProjectTeam());
		}
	};

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<div>
			<div className="flex justify-between items-center mb-4">
				<span />
				<Button type="primary" className="project-apply-btn" onClick={() => setTeamModalOpen(true)}>
					Add Team to Project
				</Button>
			</div>
			<Card>
				<h1 className='text-xl mb-4'> Team List </h1>
				<Table
					scroll={{ x: true }}
					loading={loading}
					pagination={{
						defaultPageSize: 20,
					}}
					columns={columnsToShow}
					dataSource={addKeys(list)}
				/>
			</Card>
			<Modal
				title="Add Team to Project"
				open={teamModalOpen}
				onCancel={() => setTeamModalOpen(false)}
				footer={null}
				width={520}
				destroyOnClose
			>
				<AddProjectTeam projectId={projectIdFromUrl} onCancel={() => { setTeamModalOpen(false); dispatch(loadAllProjectTeam()); }} />
			</Modal>
		</div>
	);
};

export default ProjectTeam;
